/* eslint import/prefer-default-export: 0 */
export function WebAuthnKey(data = {}) {
  this.attachment = data.attachment;
  this.id = data.id;
  this.credentialId = data.credentialId;
  this.name = data.name;
  this.registrationDate = data.registrationDate;
  this.enabled = data.enabled;

  return this;
}
